module.exports = __webpack_public_path__ + "img/st.6a98b4a4.svg";